import type { Schemas } from '#shopware';
import type { CustomProductFields } from '~/types/shopware';

export function isProductVisibleForUser(
    product: Schemas['Product'] & CustomProductFields,
    shopwareUser: Schemas['Customer'] | undefined,
    excludedCategoryName = ''
) {
    const hiddenRoles =
        product.customFields?.custom_product_constraints_restricted_for_groups ||
        product.translated?.customFields?.custom_product_constraints_restricted_for_groups ||
        [];
    const hiddenCountries =
        product.customFields?.custom_product_constraints_restricted_for_languages ||
        product.translated?.customFields?.custom_product_constraints_restricted_for_languages ||
        [];

    const userGroupId = shopwareUser?.groupId || '';
    const userLanguageId = shopwareUser?.languageId || '';

    const roleExcluded = hiddenRoles.includes(userGroupId);

    // language is used intentionally to exclude the country
    // user country is not always set if the user is new
    // language is safer to use
    // https://jira.hmmh.de/browse/MP-856?focusedId=1901164&page=com.atlassian.jira.plugin.system.issuetabpanels:comment-tabpanel#comment-1901164
    const languageExcluded = hiddenCountries.includes(userLanguageId);

    const isInExcludedCategory = product.categories?.some((category) => category.name === excludedCategoryName);

    return !(isInExcludedCategory || (roleExcluded && languageExcluded));
}
